import { DASHBOARD_HOME } from '@yourownmetric/shared'

/**
 * Where to go after signing in: `?next=` when it is a path on this host
 * (e.g. back to `/accept-invite?token=…`), else the dashboard home.
 * Absolute, protocol-relative and backslash URLs are refused (open redirect).
 */
export function safeNextPath(next: string | null | undefined): string {
    if (!next || !next.startsWith('/') || next.startsWith('//') || next.includes('\\')) {
        return DASHBOARD_HOME
    }
    return next
}
